function getEnvVar(key, fallback) {
    try {
        var _process_env_key;
        return (_process_env_key = process.env[key]) !== null && _process_env_key !== void 0 ? _process_env_key : fallback;
    } catch (e) {
        return fallback;
    }
}

export { getEnvVar };
